<template>
	<div class="brick">
		<div class="left_option">
			<div class="list_top_box">
				<em class="lt_text">Query Scan</em>
				<span class="int_type mm_int mgr_10">
					<input type="text" v-model.trim="keyword" placeholder="Employee No. or Barcode Scan" autofocus autocomplete="off" @keyup.enter="scan()" />
				</span>

				<em class="lt_text mgl_15">Scan Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text">Staff</em>
				<span class="int_type_no_border int_type mgr_10">
					<select v-model="staff_id">
						<option :value="null">ALL</option>
						<option disabled>-----------------------------------</option>
						<option v-for="(staff, index) in staff_list" :key="index" :value="staff.user_id">{{ staff.name }}</option>
					</select>
				</span>

				<a href="javascript:;" @click="selectLoginIdList()" class="search_bt">Search</a>
				<a href="javascript:;" @click="reset()" class="gray_bt mgr_15">Reset</a>

				<a href="javascript:;" @click="exportExcel()" class="gray_bt">Download</a>
				<span :class="search_user_id ? [] : ['border_box', 'mgl_15']">
					<a href="javascript: void(0);" class="gray_bt mgr_5" @click="print">Print</a>

					<template v-if="!search_user_id">
						<label class="mgr_5">
							<input type="radio" :value="print_type.by_staff" v-model="selected_print_type" />
							<em class="lt_text">By Staff</em>
						</label>
						<label>
							<input type="radio" :value="print_type.by_date" v-model="selected_print_type" />
							<em class="lt_text">By Date</em>
						</label>
					</template>
				</span>

				<a href="javascript:;" @click="holiday()" class="gray_bt" style="margin-left:100px;">Holiday</a>
			</div>
		</div>

		<CommonTable :tbl_headers="tbl_headers" :data="display_records" @sort="sort" :sort_key="search_sort_key" :sort_direction="search_sort_direction" @updateAttendanceReason="updateAttendanceReason" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiInsertLoginIdScan, apiSelectLoginIdList, apiUpdateAttendanceReason } from '@/api/dc/loginidscan.js';
import { today, convertMDYToYMD, convertMinToHour, getDayByMySQLDayOfWeek } from '@/utils/date.js';
import { getMrtFile, Report, reportMrtUrl, PrintType, exportDataExcel } from '@/api/util';
import { shallowCopy } from '@/utils/etc.js';
import { apiSelectUserList } from '@/api/basicinfo/user';
import { defaultDataType } from 'export-xlsx';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
export default {
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'N',

			from_date: today(),
			to_date: today(),

			search_from_date: null, // sort시 조건으로 사용하므로 excel export 시 사용 안함.
			search_to_date: null, // sort시 조건으로 사용하므로 excel export 시 사용 안함.
			search_user_id: null,
			search_sort_key: null,
			search_sort_direction: null,

			sort_key: null,
			sort_direction: null,

			keyword: null,

			logs: [],
			display_records: [],
			tbl_headers: [],

			staff_id: null,
			staff_list: [],

			just_scnned_user_id: null,

			print_type: {
				by_staff: 0,
				by_date: 1,
			},
			selected_print_type: 0,
		};
	},
	components: {
		CustomDatePicker,
		CommonTable,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		isBeautyplus() {
			return this.company_id === 'beautyplus';
		},
		isHairplus() {
			return this.company_id === 'hairplus';
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	methods: {
		holiday() {
			var vm = this;
			this.$alertify.confirm('Are you sure to treat as holiday?', () => {
				vm.display_records.forEach(r => {
					if (r.user_id) {
						r.reason = 'Holiday';
						vm.updateAttendanceReason(r);
					}
				});
			});
		},
		sort(header) {
			const sort_key = header.key;

			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectLoginIdList();
		},
		reset() {
			this.from_date = today();
			this.to_date = today();
			this.staff_id = null;
			this.sort_key = null;
			this.sort_direction = null;
			this.selected_print_type = 0;

			this.selectLoginIdList();
		},
		async scan() {
			if (!this.keyword) {
				this.$toast.error('Empty Keyword');
				return;
			}

			const { data } = await apiInsertLoginIdScan({ keyword: this.keyword });
			if (data.result) {
				//console.log(data.log_dt, data.scanUser);
				//this.logs.unshift({ user_id: data.scanUser.user_id, user_name: data.scanUser.name, log_dt: data.log_dt, keyword: this.keyword });
				this.$toast.success(data.scanUser.name + ' scanned.');
				this.just_scnned_user_id = data.scanUser.user_id;

				this.sort_key = null;
				this.sort_direction = null;
				await this.selectLoginIdList();
			} else {
				this.$toast.error(data.msg);
			}

			this.keyword = null;
		},
		async updateAttendanceReason(attend) {
			const { data } = await apiUpdateAttendanceReason({
				user_id: attend.user_id,
				attend_date: convertMDYToYMD(attend.log_date_str),
				reason: attend.reason,
				memo: attend.memo,
			});

			if (data > 0) this.$toast.success('Saved Successfully.');
		},
		async exportExcel() {
			const { data } = await apiSelectLoginIdList({
				from_date: this.search_from_date,
				to_date: this.search_to_date,
				user_id: this.search_user_id,
				for_export: true,
			});

			if (Array.isArray(data.logList)) data.logList.forEach(log => (log.keyword2 = log.keyword));

			exportDataExcel(data.logList, this.defaultExcelHeader(), 'Login ID Scan List_' + this.search_from_date + '_' + this.search_to_date);
		},
		makePrintData() {
			const data = [];
			this.logs.forEach(el => {
				if (Array.isArray(el.scan_list)) {
					el.scan_list.forEach(scan => {
						const idx = data.findIndex(d => d.scan_date === el.log_date_str);
						const log = {
							user_name: el.user_name,
							user_id: el.user_id,
							dt_in: scan.dt_in,
							dt_out: scan.dt_out,
							keyword: scan.keyword,
						};

						if (idx < 0) {
							data.push({
								scan_date: el.log_date_str,
								logs: [log],
							});
						} else {
							data[idx].logs.push(log);
						}
					});
				}
			});

			data.forEach(el => {
				let all_cnt = 0;
				let presented_cnt = 0;
				let prev_user_id = null;
				el.logs.forEach(l => {
					if (prev_user_id !== l.user_id) {
						prev_user_id = l.user_id;
						all_cnt++;
						if (l.dt_in) presented_cnt++;
					}

					l.user_id_index = all_cnt;
				});

				el.all_cnt = all_cnt;
				el.presented_cnt = presented_cnt;
				el.absent_cnt = all_cnt - presented_cnt;
			});

			return data;
		},
		makePrintDataByUserId() {
			const data = [];
			const map_list = this.logs.map((el, index) => ({
				display_no: index,
				user_id: el.user_id,
				log_date_str: el.log_date_str,
				user_name: el.user_name,
				day_of_week: getDayByMySQLDayOfWeek(el.day_of_week),
				week_number: el.week_number,
				reason: el.reason,
				memo: el.memo,
				work_in_dt: el.work_in_dt && el.work_in_dt.split(' ').length > 1 ? el.work_in_dt.split(' ')[1] : null,
				work_out_dt: el.work_out_dt && el.work_out_dt.split(' ').length > 1 ? el.work_out_dt.split(' ')[1] : null,
				work_duration: el.work_duration,
				work_duration_by_hour: convertMinToHour(el.work_duration),
			}));

			map_list.forEach(el => {
				const idx = data.findIndex(d => d.user_id === el.user_id);
				if (idx > -1) {
					data[idx].data.push(el);
				} else {
					data.push({
						name: el.user_name,
						user_id: el.user_id,
						period: this.search_from_date + '~' + this.search_to_date,
						// totoal_hour: convertMinToHour(total_work_duration),
						data: [el],
					});
				}
			});

			data.forEach(el => (el.totoal_hour = convertMinToHour(el.data.reduce((prev, curr) => prev + curr.work_duration, 0))));
			data.sort((a, b) => {
				if (a.name > b.name) return 1;
				else if (a.name < b.name) return -1;
				else return 0;
			});

			return data;
		},
		async print() {
			if (!this.logs || !this.logs.length) {
				this.$toast.error('No List to Be Shown');
			}

			let data = null;
			let file_name = null;
			if (this.search_user_id || !this.selected_print_type) {
				data = this.makePrintDataByUserId();
				file_name = 'CommuteLog';
			} else {
				data = this.makePrintData();
				file_name = 'LoginIDScan';
			}

			const reportTemplate = await getMrtFile(reportMrtUrl(file_name));
			const report = new Report(reportTemplate, data, file_name, PrintType.List);
			this.$store.commit('setReport', report);
		},

		async selectLoginIdList() {
			const param = {
				from_date: this.from_date,
				to_date: this.to_date,
				user_id: this.staff_id,
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
			};

			this.search_from_date = param.from_date;
			this.search_to_date = param.to_date;
			this.search_user_id = param.user_id;
			this.search_sort_key = param.sort_key;
			this.search_sort_direction = param.sort_direction;

			this.setHeaders(this.search_user_id);

			const { data } = await apiSelectLoginIdList(param);

			this.logs = data.logList;
			this.display_records = this.makeDisplayRecords(this.logs, this.search_user_id);
			this.setRowMergeData();
		},
		makeDisplayRecords(data, searchUserId) {
			if (!Array.isArray(data)) return [];

			const display_records = [];
			let index = 0;
			let presented_cnt = 0;
			let prev_date = null;
			let date_start_index = 0;

			const addTotalRow = (date, start_idx, all, present) => {
				display_records.splice(start_idx, 0, {
					is_colspan_record: true,
					log_date_str: date,
					columns: [
						{ colspan: 1, key: 'log_date_str', log_date_str: date },
						{ colspan: this.tbl_headers.length - 1, html_str: `<font class="mgr_10">ALL:${all}</font> <font class="mgr_10">Presented:${present}</font> <font class="mgr_10">Absent:${all - present}</font>`, td_class: 'td_title' },
					],
				});
			};

			data.forEach(attend => {
				if (!prev_date) {
					prev_date = attend.log_date_str;
				} else if (prev_date !== attend.log_date_str) {
					if (!searchUserId) addTotalRow(prev_date, date_start_index, index, presented_cnt);
					prev_date = attend.log_date_str;
					index = 0;
					presented_cnt = 0;
					date_start_index = display_records.length;
				}

				index++;
				if (attend.work_in_dt) presented_cnt++;

				if (Array.isArray(attend.scan_list) && attend.scan_list.length) {
					attend.scan_list.forEach(scan => {
						const obj = this.mergeObject(shallowCopy(attend, 'scan_list'), shallowCopy(scan));
						obj.display_no = index;

						if (attend.work_in_dt) {
							this.addCellStyle(obj, 'user_id', 'red_letter');
							this.addCellStyle(obj, 'user_name', 'red_letter');
						}
						if (this.just_scnned_user_id === attend.user_id) {
							this.addCellStyle(obj, 'user_id', 'bg_yellow');
							this.addCellStyle(obj, 'user_name', 'bg_yellow');
						}

						display_records.push(obj);
					});
				} else {
					const obj = shallowCopy(attend, 'scan_list');
					obj.display_no = index;
					display_records.push(obj);
				}
			});

			if (!searchUserId) addTotalRow(prev_date, date_start_index, index, presented_cnt);

			return display_records;
		},
		addCellStyle(obj, prop, css_class) {
			if (!obj.cell_style) obj.cell_style = {};

			if (!obj.cell_style[prop]) obj.cell_style[prop] = [css_class];
			else obj.cell_style[prop].push(css_class);
		},
		mergeObject(obj1, obj2) {
			const res = { ...obj1 };
			for (const key of Object.keys(obj2)) {
				if (!res[key]) res[key] = obj2[key];
			}

			return res;
		},
		setRowMergeData() {
			const merge_data = this.makeRowMergeInfo(this.display_records, this.search_user_id);

			if (merge_data) {
				for (const key of Object.keys(merge_data)) {
					let idx = this.tbl_headers.findIndex(h => h.key === key);
					if (idx > -1) this.tbl_headers[idx].row_merge = merge_data[key];
				}
			}
		},
		makeRowMergeInfo(records, searchUserId) {
			if (!Array.isArray(records) || !records.length) return null;

			let cri1 = null;
			let cri2 = null;
			if (!searchUserId) {
				cri1 = 'log_date_str';
				cri2 = 'user_id';
			} else {
				cri1 = 'user_id';
				cri2 = 'log_date_str';
			}

			let prev_cri1 = null;
			let prev_cri2 = null;
			let cri1_merge_list = [];
			let cri2_merge_list = [];
			let tmp_cri1_merge = {};
			let tmp_cri2_merge = {};
			records.forEach((record, index) => {
				const tmp_cri1 = record[cri1];
				const tmp_cri2 = record[cri2];

				if (prev_cri1 === tmp_cri1) {
					tmp_cri1_merge.end = index;

					if (prev_cri2 === tmp_cri2) {
						tmp_cri2_merge.end = index;
					} else {
						if (tmp_cri2_merge.end) cri2_merge_list.push(tmp_cri2_merge);
						tmp_cri2_merge = { start: index };
						prev_cri2 = tmp_cri2;
					}
				} else {
					if (tmp_cri1_merge.end) cri1_merge_list.push(tmp_cri1_merge);
					if (tmp_cri2_merge.end) cri2_merge_list.push(tmp_cri2_merge);
					tmp_cri1_merge = { start: index };
					tmp_cri2_merge = { start: index };
					prev_cri1 = tmp_cri1;
					prev_cri2 = tmp_cri2;
				}
			});

			if (tmp_cri1_merge.end) cri1_merge_list.push(tmp_cri1_merge);
			if (tmp_cri2_merge.end) cri2_merge_list.push(tmp_cri2_merge);

			return {
				log_date_str: searchUserId ? cri2_merge_list : cri1_merge_list,
				user_name: searchUserId ? cri1_merge_list : cri2_merge_list,
				user_id: searchUserId ? cri1_merge_list : cri2_merge_list,
				display_no: cri2_merge_list,
				reason: cri2_merge_list,
				memo: cri2_merge_list,
				reason_memo_upd: cri2_merge_list,
			};
		},
		defaultExcelHeader() {
			const header = [
				{ key: 'log_date_str', name: 'Date', width: 15, dataType: defaultDataType.string },
				{ key: 'log_time_str', name: 'Time', width: 15, dataType: defaultDataType.string },
				{ key: 'keyword2', name: 'Message', width: 15, dataType: defaultDataType.string },
				{ key: 'keyword', name: 'CARD NO', width: 15, dataType: defaultDataType.string },
				{ key: 'user_id', name: 'User ID', width: 15, dataType: defaultDataType.string },
				{ key: 'user_name', name: 'User Name', width: 15, dataType: defaultDataType.string },
			];

			return header;
		},
		setReasonOptions() {
			if (this.isBeautyplus) return this.beautyplusReasonOptions();
			else if (this.isHairplus) return this.hairplusReasonOptions();
			else return this.beautyplusReasonOptions(); // default
		},
		beautyplusReasonOptions() {
			return [
				{ value: null, display: '' },
				{ value: 'Out of office for a short time', display: 'Out of office for a short time' },
				{ value: 'Leave early', display: 'Leave early' },
				{ value: 'Late', display: 'Late' },
				{ value: 'Vacation', display: 'Vacation' },
				{ value: 'Day off with notice', display: 'Day off with notice' },
				{ value: 'Day off without notice', display: 'Day off without notice' },
				{ value: 'Holiday', display: 'Holiday' },
			];
		},
		hairplusReasonOptions() {
			return [
				{ value: null, display: '' },
				{ value: 'Out of office for a short time', display: 'Out of office for a short time' },
				{ value: 'Business trip', display: 'Business trip' },
				{ value: 'Leave early', display: 'Leave early' },
				{ value: 'Late', display: 'Late' },
				{ value: 'Vacation', display: 'Vacation' },
				{ value: 'Day off with notice', display: 'Day off with notice' },
				{ value: 'Day off without notice', display: 'Day off without notice' },
				{ value: 'Holiday', display: 'Holiday' },
			];
		},
		defaultHeader() {
			const header = [
				{ key: 'log_date_str', name: 'Date', tbl_width: '80px', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'display_no', name: 'No.', tbl_width: '40px', td_class: 'al_center' },
				{ key: 'user_name', name: 'User Name', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'user_id', name: 'User ID', tbl_width: '200px', td_class: 'al_left' },
				{ key: 'dt_in', name: 'In', tbl_width: '160px', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'dt_out', name: 'Out', tbl_width: '160px', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'keyword', name: 'Scan ID', tbl_width: '160px', td_class: 'al_left' },
			];

			return header;
		},
		searchByUserIdHeader() {
			const header = [
				{ key: 'user_name', name: 'User Name', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'user_id', name: 'User ID', tbl_width: '200px', td_class: 'al_left' },
				{ key: 'log_date_str', name: 'Date', tbl_width: '80px', td_class: 'al_center', th_click_event: 'sort' },
				{ key: 'dt_in', name: 'In', tbl_width: '160px', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'dt_out', name: 'Out', tbl_width: '160px', td_class: 'al_left', th_click_event: 'sort' },
				{ key: 'keyword', name: 'Scan ID', tbl_width: '160px', td_class: 'al_left' },
			];

			return header;
		},
		headerByModifiable() {
			const select_options = this.setReasonOptions();
			let header = null;
			if (this.modifiable) {
				header = [
					{ key: 'reason', name: 'Reason', tbl_width: '160px', td_class: 'al_center', select_options },
					{ key: 'memo', name: 'Memo', tbl_width: '200px', td_class: 'al_left', input_type: 'text' },
					{ key: 'reason_memo_upd', name: 'Upd.', tbl_width: '80px', td_class: 'al_center', button_info: { display: 'Upd.', class: 'gray_bt', click_event: 'updateAttendanceReason' } },
				];
			} else {
				header = [
					{ key: 'reason', name: 'Reason', tbl_width: '160px', td_class: 'al_center' },
					{ key: 'memo', name: 'Memo', tbl_width: '200px', td_class: 'al_left' },
				];
			}

			return header;
		},
		setHeaders(searchByUserId) {
			const header = searchByUserId ? this.searchByUserIdHeader() : this.defaultHeader();
			header.push(...this.headerByModifiable());
			this.tbl_headers = header;
		},
		async getStaffList() {
			let { data } = await apiSelectUserList({
				active_yn: 'Y',
				sort_key: 'user_name',
			});

			if (this.isBeautyplus) this.staff_list = data.userList.filter(user => user.user_type === 'whstaff');
			else if (this.isHairplus) this.staff_list = data.userList.filter(user => user.login_id_scan);
			else this.staff_list = data.userList.filter(user => user.login_id_scan); // default
		},
	},
	async created() {
		await this.getStaffList();

		this.$store.commit('setSideIndex', 6);
		this.$store.commit('setSelectedMenu', 'nav_li_login_id_scan');
		this.$store.commit('setSubTitle', 'Daily Closing -> Login ID Scan');

		this.selectLoginIdList();
		//this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
